/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/IDE-exercise/v3.ts
 */

import { createValidator } from '../../helpers/validator';
export const IDEExerciseV3Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    language: {
      type: 'string',
      enum: ['r', 'python', 'revo', 'sql', 'shell', 'scala', 'julia', 'containers']
    },
    runtime_config: {
      type: 'string'
    },
    assignment: {
      type: 'string'
    },
    pre_exercise_code: {
      type: 'string',
      default: ''
    },
    instructionSteps: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          hint: {
            type: 'string',
            description: 'The hint text for this step.'
          },
          instructions: {
            type: 'string',
            description: 'The instructions text for this step.'
          }
        },
        required: ['hint', 'instructions']
      },
      title: 'Instruction steps',
      description: 'Incremental instruction steps. These can not be empty.',
      minItems: 1
    },
    sampleCodeFiles: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          path: {
            type: 'string',
            description: 'Path of the file to create.'
          },
          open: {
            type: 'boolean',
            default: false,
            description: 'Should we open the file by default?'
          },
          content: {
            type: 'string',
            default: '',
            description: 'Content of the file.'
          },
          permission: {
            type: 'number',
            default: 755,
            description: 'Unix permission of the file (755 = read/write access).'
          }
        },
        required: ['path']
      }
    },
    solutionCodeFiles: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          path: {
            type: 'string',
            description: 'Path of the file to create.'
          },
          open: {
            type: 'boolean',
            default: false,
            description: 'Should we open the file by default?'
          },
          content: {
            type: 'string',
            default: '',
            description: 'Content of the file.'
          },
          permission: {
            type: 'number',
            default: 755,
            description: 'Unix permission of the file (755 = read/write access).'
          }
        },
        required: ['path']
      }
    },
    sct: {
      type: 'string',
      default: ''
    },
    solutionInstructions: {
      type: 'string',
      title: 'Solution Instructions',
      description: 'The instructions to make the exercise pass after getting the solution.'
    }
  },
  required: ['assignment', 'chapter_id', 'course_id', 'instructionSteps', 'language', 'pre_exercise_code', 'sampleCodeFiles', 'sct', 'solutionCodeFiles', 'solutionInstructions', 'title', 'xp'],
  definitions: {}
};
export const isValidIDEExerciseV3 = createValidator(IDEExerciseV3Schema);
export const IDEExerciseV3Definition = {
  schema: IDEExerciseV3Schema,
  validate: isValidIDEExerciseV3
};